import React, { FC, PropsWithChildren } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import styles from './sortable.component.module.scss';


interface SortableItemComponentProps extends PropsWithChildren {
    id: string;
    index: number;
}

const SortableItemComponent: FC<SortableItemComponentProps> = ({ id, index, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition: isDragging ? undefined : transition, // Disable transition during drag for instant response
        opacity: isDragging ? 0.4 : 1,
        touchAction: 'none',
        zIndex: isDragging ? 999 : 'auto',
        position: 'relative' as 'relative',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`sortable-item ${styles["sortable-item"]} col-12 mb-2 g-0`}
        >
            <div
                className={`d-flex align-items-center sort-handler ${styles['sort-handler']}`}
                {...attributes}
                {...listeners}
            >
                <img width={"16px"} height={"16px"}
                    src="/icons/svg/drag-handler.svg"
                    alt='Drag'
                />
            </div>
            <div className='flex-grow-1'>
                {children}
            </div>
        </div>
    );
};

export default SortableItemComponent;
